import { createReducer, on } from '@ngrx/store';
import { AssignedVendorToSubcategoryEvent } from './vendor-rate.events';
import { VendorRateState } from './vendor-rate.state';

export const vendorRateKey = 'vendorRate';
export const initialState: VendorRateState = {
  entities: {},
};

export const VendorRateReducer = createReducer(
  initialState,
  on(AssignedVendorToSubcategoryEvent, (state) => state)
);
